<template>
<div :class="$style['coupon-download']">
    <div :class="$style['copy-url']">
        <wt-input :value="downloadUrl" :disabled="true"></wt-input>
        <pt-copy-button :copyContent="downloadUrl"></pt-copy-button>
    </div>
    <div :class="$style['download-qr-content']">
        <img src="@/assets/images/coupon-download.png" />
        <div :class="$style['download-qr-message']">
            <div :class="$style['table-content']">
                <div :class="$style['coupon-name']">{{couponData.name}}</div>
                <table>
                    <tr>
                        <td  :class="$style['coupon-content-text']" >
                            <template  v-if="type==='coupon'">内容</template>
                            <template v-else>礼包</template>
                            </td>
                        <td><div  :class="$style['coupon-time']"><div>：</div><span :class="$style['coupon-amount']">{{couponMassage.discount}}</span>
                        <span v-if="type==='coupon'">满{{couponMassage.thresholdOfAmount}}元可使用</span>
                        <span v-else>
                            {{couponMassage.amount}}张（优惠劵）
                        </span>
                        </div></td>
                    </tr>
                    <tr>
                        <td  :class="$style['coupon-content-text']"><div>有效期</div></td>
                        <td>
                            <div :class="$style['coupon-time']"><div>：</div>{{couponMassage.startTime_day}}<span :class="$style['time-text']">至</span>{{couponMassage.endTime_day}}</div>
                        </td>
                    </tr>
                </table>
            </div>
            <div :class="$style['coupon-qr-code-img']">
                <img :src="downloadUrl"/>
            </div>
        </div>
    </div>
    <div class="button-div">
        <el-button type="primary" @click="downloadQRCode">下载二维码</el-button>
    </div>
</div>
</template>
<script>
export default {
  props: {
    couponMassage: {
      type: Object,
      default: function () {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    couponData () {
      return this.type === 'coupon' ? (this.couponMassage.couponData || {}) : (this.couponMassage.promotionData || {})
    }
  },
  data () {
    return {
      privateResourcesUrl: this.$privateResourcesUrl,
      downloadUrl: ''
    }
  },
  methods: {
    downloadQRCode () {
      let data = {
        resourcePath: this.couponMassage.qrCode,
        download: true,
        fileName: this.couponData.name + '.jpg'
      }
      this.$store.dispatch('downloadPrivateResource', data).then(res => {
        window.open(res)
      })
    },
    getResuorceUrl () {
      let data = {
        resourcePath: this.couponMassage.qrCode
      }
      this.$store.dispatch('getResuorceUrl', data).then(res => {
        this.downloadUrl = res
      }).catch(err => {
        this.$message.error(err || '获取下载链接失败')
      })
    }
  },
  created () {
    this.getResuorceUrl()
  }
}
</script>
<style module lang="less">
@import "~less/var.less";
.coupon-content-text{
    text-align-last:justify;
    text-align:justify;
    text-justify:distribute-all-lines;
    display: grid;
    line-height: 30px;
}
.coupon-download{
    :global
    .button-div{
        padding:0
    }
}
.copy-url{
    display: flex;
    justify-content: center;
    :global
    .wt-input{
        display: flex;
        flex: 1
    }
    :global
    .el-button{
        margin-left: 10px;
    }
}
.download-qr-content{
    border: @mainColor solid 1px;
    margin-top: 10px;
    img{
        width: 100%
    }
}
.download-qr-message{
    padding: 10px;
    display: flex;
    :global
    table{
        font-size: 15px;
    }
}
.time-text{
    margin: 0 8px;
}
.coupon-name{
    font-size: 16px;
    font-weight: 600;
    line-height: 50px;
}
.coupon-amount{
    margin-right: 10px;
}
.table-content{
   flex: 1
}
.coupon-qr-code-img{
    width: 30%
}
.coupon-time{
    display: -webkit-inline-box
}
</style>
